import { render, staticRenderFns } from "./Keseminatan.vue?vue&type=template&id=128fee60"
import script from "./Keseminatan.vue?vue&type=script&lang=js"
export * from "./Keseminatan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports